function Statistics_icon({ selected }: { selected: boolean }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.6 9.99999H5.2C4.88179 9.99999 4.57655 10.1264 4.35143 10.3514C4.12643 10.5766 4 10.8818 4 11.2V18.4C4 18.7182 4.12643 19.0234 4.35143 19.2485C4.57656 19.4735 4.88179 19.6 5.2 19.6H7.6C7.91821 19.6 8.22345 19.4735 8.44857 19.2485C8.67357 19.0234 8.8 18.7182 8.8 18.4V11.2C8.8 10.8818 8.67357 10.5765 8.44857 10.3514C8.22344 10.1264 7.91821 9.99999 7.6 9.99999ZM5.2 18.4V11.2H7.6V18.4H5.2ZM13.6 6.99999H11.2C10.8818 6.99999 10.5766 7.12642 10.3514 7.35142C10.1264 7.57656 10 7.88179 10 8.19999V18.4C10 18.7182 10.1264 19.0234 10.3514 19.2485C10.5766 19.4735 10.8818 19.6 11.2 19.6H13.6C13.9182 19.6 14.2235 19.4735 14.4486 19.2485C14.6736 19.0234 14.8 18.7182 14.8 18.4V8.19999C14.8 7.88178 14.6736 7.57654 14.4486 7.35142C14.2234 7.12642 13.9182 6.99999 13.6 6.99999ZM11.2 18.4V8.19999H13.6V18.4H11.2ZM19.6 4H17.2C16.8818 4 16.5766 4.12643 16.3514 4.35143C16.1264 4.57656 16 4.88179 16 5.2V18.4C16 18.7182 16.1264 19.0234 16.3514 19.2485C16.5766 19.4735 16.8818 19.6 17.2 19.6H19.6C19.9182 19.6 20.2235 19.4735 20.4486 19.2485C20.6736 19.0234 20.8 18.7182 20.8 18.4V5.2C20.8 4.88179 20.6736 4.57655 20.4486 4.35143C20.2234 4.12643 19.9182 4 19.6 4ZM17.2 18.4V5.2H19.6V18.4H17.2Z"
        fill={selected ? "#AA84A1" : "#53514D"}
      />
    </svg>
  );
}

export default Statistics_icon;
